import React from 'react';
import {Link, useNavigate} from "react-router-dom";
import {convertToJalaliWithFormat} from "@/lib/utils/date";
import {Can, hasPermissionLink} from "@/components/can/Can";
import PermList from "@/lib/helper/PermList";
import {sprintf} from "@/lib/utils/sprintf";
import {URLS} from "@/lib/urls";
import {Button} from "antd";
import AdminLayout from "@/components/layout/admin/adminLayout";
import TableSearch from "@/components/table/tableSearch";
import {useApiSearchAdminProducts} from "@/api/product";

function AdminProductList(props) {
    const navigate = useNavigate();

    const columns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id',
            width: 70,
        },
        // {
        //     title: 'تصویر',
        //     dataIndex: 'file',
        //     key: 'file',
        //     width: 100,
        //     render: (file, record) => {
        //         if (file && file?.url) {
        //             return (
        //                 <img
        //                     src={file?.url}
        //                     alt={file?.filename || 'محصول'}
        //                     className="w-16 h-16 object-cover rounded-md border dark:border-gray-600 border-gray-200"
        //                 />
        //             );
        //         }
        //         return (
        //             <div className="w-16 h-16 bg-gray-100 rounded-md flex items-center justify-center   text-xs border dark:border-gray-600 border-gray-200">
        //                 بدون تصویر
        //             </div>
        //         );
        //     }
        // },
        {
            title: 'عنوان',
            dataIndex: 'title',
            key: 'title',
            render: (text, record) => (
                <span className="font-medium">{text || 'بدون عنوان'}</span>
            )
        },

        {
            title: 'تحویل به',
            dataIndex: 'deliver_to',
            key: 'deliver_to',
            responsive: ['md'],
            render: (text) => {
                if(text === 'user')
                {
                    return 'خود دانش آموز'
                }

                if(text === 'teacher')
                {
                    return 'مربی'
                }

                    return 'مربی + دانش آموز'

            }

        },
        {
            title: 'وضعیت',
            dataIndex: 'status',
            key: 'status',
            width: 120,
            render: (text, record) => {
                const statusColors = {
                    draft: 'bg-yellow-100 text-yellow-800',
                    published: 'bg-green-100 text-green-800',
                    archived: 'bg-gray-100  '
                };
                const statusLabels = {
                    draft: 'پیش‌نویس',
                    published: 'منتشر شده',
                    archived: 'بایگانی شده'
                };
                return (
                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${statusColors[text] || 'bg-gray-100'}`}>
                    {statusLabels[text] || text}
                </span>
                );
            }
        },
        {
            title: 'جنسیت',
            dataIndex: 'gender',
            key: 'gender',
            width: 100,
            responsive: ['md'],
            render: (gender) => {
                const genderLabels = {
                    all: 'همه',
                    male: 'مرد',
                    female: 'زن'
                };
                return genderLabels[gender] || gender || '-';
            }
        },
        {
            title: 'تاریخ ثبت',
            dataIndex: 'created_at',
            key: 'created_at',
            responsive: ['md'],
            render: (text, record) => {
                return convertToJalaliWithFormat(text, 'jYYYY/jMM/jDD HH:mm:ss');
            }
        },
        {
            title: 'عملیات',
            dataIndex: 'id',
            key: 'actions',
            width: 120,
            render: (text, record) => {
                return (
                    <Link
                        to={hasPermissionLink(PermList.PRODUCT_EDIT, sprintf(URLS.admin.products.edit, {id: record.id}))}
                    >
                        <Button size={'small'} variant={'filled'} color={'primary'}>
                            ویرایش
                        </Button>
                    </Link>
                );
            }
        },
    ];


    return (
        <AdminLayout backTo={URLS.admin.products.dashboard} pageTitle={'لیست محصولات'}>

            <TableSearch
                searchInput={true}
                addButton={
                    <div className={'flex justify-end gap-1'}>

                        <Can permission={PermList.PRODUCT_ADD}>
                            <Button
                                color={'primary'}
                                variant={'solid'}
                                size={'medium'}
                                onClick={() => navigate(URLS.admin.products.create)}>
                                <div className={'hidden md:flex'}>
                                    افزودن محصول جدید
                                </div>
                                <div className={'flex md:hidden'}>
                                    +
                                </div>

                            </Button>
                        </Can>


                    </div>
                }
                apiFn={useApiSearchAdminProducts}
                columns={columns}
                scroll={{x: true}}
                responsive={true}
            />

        </AdminLayout>
    );
}

export default AdminProductList;